// @flow
import * as React from 'react';

import ConfirmDialog from 'components/ConfirmDialog';
import Text from 'components/Text';

import type { Props as ConfirmDialogProps } from 'components/ConfirmDialog'; // eslint-disable-line no-unused-vars

type Props = {
  messageName: ?string,
  /* :: ...$Shape<ConfirmDialogProps>, */
};

export default class AdminAutoMessagesDeleteConfirmDialog extends React.Component<Props, *> {
  render() {
    const { messageName, ...props } = this.props;
    return (
      <ConfirmDialog
        title={
          <React.Fragment>
            Are you sure you want to delete{' '}
            {messageName ? <Text weight="semibold">{messageName}</Text> : 'this message'}?
          </React.Fragment>
        }
        actionButtonText="Delete"
        cancelButtonText="Cancel"
        actionButtonColor="apple"
        {...props}
      />
    );
  }
}
